import authInstance from 'config/axios.config';

export const mainCategoryServices = {
  getMainCategories: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== 'all' && value !== undefined && value !== null) {
        params.append(key, String(value));
      }
    });

    params.append('level', '0');

    const res = await authInstance.get(`/admin/category?${params}`);
    return res.data;
  },

  toggleActiveStatus: async () => {},

  addMainCategory: async (payload) => {
    const res = await authInstance.post('/admin/category', payload);
    return res.data;
  },

  updateMainCategory: async ({ categoryId, data }) => {
    const res = await authInstance.put(`/admin/category/${categoryId}`, data);
    return res.data;
  },

  deleteMainCategory: async (categoryId) => {
    const res = await authInstance.delete(`/admin/category/${categoryId}/hard-delete`);
    return res.data;
  },

  softDeleteMainCategory: async (categoryId) => {
    const res = await authInstance.delete(`/admin/category/${categoryId}`);
    return res.data;
  },

  toggleActiveStatus: async (categoryId) => {
    const res = await authInstance.patch(`/admin/category/${categoryId}/toggle-active`);
    return res.data;
  },

  exportCategories: async ({
    level,
    isActive,
    isPopular,
    isFeatured,
    search,
    sortBy,
    sortOrder,
  }) => {
    const params = new URLSearchParams({
      level: level === 'all' ? '' : level || '',
      isActive: isActive === 'all' ? '' : isActive || '',
      isPopular: isPopular === 'all' ? '' : isPopular || '',
      isFeatured: isFeatured === 'all' ? '' : isFeatured || '',
      search: search || '',
      sortBy: sortBy || 'displayOrder',
      sortOrder: sortOrder || 'asc',
    });

    for (const [key, value] of [...params.entries()]) {
      if (!value) params.delete(key);
    }

    return authInstance.get(
      `/admin/category/export?${params.toString()}`,
      {
        responseType: 'blob',
      }
    );
  },
};
